<template>
  <div class="wenti_box">
    <div class="list-item">
      <div class="title">
        <div class="title-icon"></div>
        <div class="questions">
          深圳市创业担保贷款的贷款期限和利率是如何规定的？
        </div>
      </div>
      <div class="content">
        <div class="answers-icon"></div>
        <div class="answers less">
          依据《深圳市创业担保贷款实施办法》，贷款期限和利率分别是：
          （一）贷款期限：创业担保贷款期限每次最长不超过3年。对还款积极、带动就业能力强、创业项目好的重点扶持对象借款人，可继续提供创业担保贷款贴息，累计次数不得超过3次。不属于重点扶持对象的借款人，只能享受1次贴息。
          （二）贷款利率：由担保基金提供担保的贷款，利率由经办银行参照贷款市场报价利率并结合借款人信用情况、风险分担方式确定，利率水平不超过1年期LPR+300BP。
        </div>
      </div>
      <div class="bottom">
        <div class="item-tag">社保</div>
        <div class="time">2022-01-20 20:28:59</div>
      </div>
    </div>
    <div class="list-item">
      <div class="title">
        <div class="title-icon"></div>
        <div class="questions">
          深圳市创业担保贷款的贷款期限和利率是如何规定的？
        </div>
      </div>
      <div class="content">
        <div class="answers-icon"></div>
        <div class="answers less">
          依据《深圳市创业担保贷款实施办法》，贷款期限和利率分别是：
          （一）贷款期限：创业担保贷款期限每次最长不超过3年。对还款积极、带动就业能力强、创业项目好的重点扶持对象借款人，可继续提供创业担保贷款贴息，累计次数不得超过3次。不属于重点扶持对象的借款人，只能享受1次贴息。
          （二）贷款利率：由担保基金提供担保的贷款，利率由经办银行参照贷款市场报价利率并结合借款人信用情况、风险分担方式确定，利率水平不超过1年期LPR+300BP。
        </div>
      </div>
      <div class="bottom">
        <div class="item-tag">社保</div>
        <div class="time">2022-01-18 19:37:07</div>
      </div>
    </div>
    <div class="list-item">
      <div class="title">
        <div class="title-icon"></div>
        <div class="questions">
          申请深圳市创业担保贷款的具体流程是怎样的？
        </div>
      </div>
      <div class="content">
        <div class="answers-icon"></div>
        <div class="answers less">
          依据《深圳市创业担保贷款实施办法》第十三条到第十六条，贷款流程是：
          （一）借款人向经办银行申请创业担保贷款，应提供完整、准确的申请材料，积极配合经办银行、担保机构等开展尽职调查。借款人在申请贷款时，对申请资料的真实性及同一笔贷款只享受一次贴息等要求应当作出书面承诺，并对不实承诺承担相应法律责任。
          （二）经办银行负责受理创业担保贷款申请，通过公共就业服务信息系统核对社保信息。经办银行应当核查申请人的信用和还款能力，对创业项目进行风险评估、贷款预审、合同拟签等。经办银行应当自受理贷款申请之日起7个工作日内，根据创业项目审核情况核定贷款额度和期限。
          （三）小微企业创业担保贷款申请，还应当由担保机构出具担保意见。担保机构应当在经办银行提供符合申请条件企业名单后，10个工作日内出具担保意见，核定贷款额度和期限。不同意担保的，担保机构应当出具不予担保意见。经办银行应当在收到担保意向书后5个工作日内完成审批。
          （四）经办银行应当通过营业网点或银行网站等渠道在杜绝个人敏感信息泄露的前提下，对贷款拟发放对象进行公示。公示有异议的，由经办银行组织开展调查，经调查异议属实的，取消借款人贷款资格。
          （五）公示7天无异议或有异议经调查不属实的，经办银行应当在3个工作日内或调查结束后按规定办理签约、放贷手续。
        </div>
      </div>
      <div class="bottom">
        <div class="item-tag">社保</div>
        <div class="time">2022-01-18 19:35:36</div>
      </div>
    </div>
    <div class="list-item">
      <div class="title">
        <div class="title-icon"></div>
        <div class="questions">
          深圳市创业担保贷款的额度是多少？
        </div>
      </div>
      <div class="content">
        <div class="answers-icon"></div>
        <div class="answers less">
          依据《深圳市创业担保贷款实施办法》（深人社规〔2020〕5号）第三章，贷款额度规定如下：
          （一）符合规定条件的个人创业担保贷款额度最高60万元，合伙经营的按符合贷款对象及条件的合伙人每人最高60万元、贷款总额最高300万元实行“捆绑性”贷款。
          （二）符合本办法第七条规定条件的小微企业创业担保贷款，额度由担保机构、经办银行根据企业经营状况、还款能力、吸纳就业情况等合理确定，最高不超过500万元。
        </div>
      </div>
      <div class="bottom">
        <div class="item-tag">社保</div>
        <div class="time">2022-01-18 19:33:41</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.wenti_box {
  width: 1438px;
  background: #fff;
  .list-item {
    box-shadow: 0 1px 0 0 #eee;
    padding-bottom: 16px;
    margin: 16px 24px 17px 24px;
    box-sizing: border-box;
    padding: 12px 0 12px 0;
    .title {
      height: 33px;
      line-height: 33px;
      display: flex;
      .title-icon {
        width: 32px;
        height: 32px;
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAIKADAAQAAAABAAAAIAAAAACPTkDJAAADcklEQVRYCb1XzWsTQRR/bybtNjGxFltBsbYKolBbvCl4qSDkpNCbH2cvCv4HQqFnL1696EFQvIi3ioIXP1DQ4gcoVGxVtG0aKzYx2WZnnvM2TdxsJ+tuwQwk+z5/v7czuzP7EEKD3h/Lrbk0JAgHUEAaSMlQSDIVpSINFY1U6HZwHg8+Xg0CYEMhmhTwZnpEEQ03bP/jKhHnYDT/DnFSM75fAJN7M9NHUdD2/0EaxiSNxdTh/DMuQvhOc+edImc+n8tw+jKvuXLVOCudHtKRjwQ/cJ0mbvD5Dzs/7Q1Dp6/MLfxXrdPM63zMnUr8niOJcnF2olYrj5PSgwTgP8iIUEOUc06671a6d8+LWPdk9phUrEAOUp6zujJ71vPcI6TVrnAeEXQRqf2V8vJl45uKW0T9NQyjWfSfxQ8Xamu/J2zk4XC3snI6bGunx54B7blH/4KY/cssYMsw+y2AWRD+JzXsCzH+YhdgKLtB5iA9dhNS/ScMdPiIUOAtP4DK63NmuVq2+8gyQrcRESvkfPeei4Y8byHnPOn7OAal/BSB1OKKXYDjbLuNmb0tyTZFbNlHTs/2mzafzRa7gEzf0NPu3IEZG0jQ1pUbeZnu3f0qaIuSYxfAIKJnZyEKzI9x+n/8KyboT1QAabccTLbJcWKCeYkKENX52WCyTY4TE8xLVAAWrj0HqC4EAVrl6kI9ptUapSUqANyvVVm4cUWT8sKgbGMfx4R9UXqyAgwSLl3/UFz8/PFXqQxVd83/sexVih/ZF0Vm88XeCYEwJQUc0oSD4C3mfq1mfTwpBPRvy0IWV3IaxEmB9EVpeAtIG2Zp0wUgiDFz3F7SBDsYpE89gfLWEXC6UpDNOMBF6G/3+YQ8bwoEgbBEgFcJ9GsbadAmzL6pgoawLFHmDfmUOWZ8cvanS3dhQD+ErZmU+RhQQMW7AMt3mqkcyzmc2zTaBMONtZljxxFVfT5DQYhipzngrhqzE3LVVVxfwfaz7ZoP/0tE+rstn0iWBHcsNifbEPCMudjJOYCJ25NzhLOOwfKGwdyC26UNnqaBRpvipoX2GMwtuFfz2yU7QZ/dnMhqxWBO5q7vA6ZX43YpDGu+8xLvE3EwfC7DybE+Afdo3KtFzEQYd9M6czT6QgYxX1qtI9iem43nHhFZ35DWrPYaIpbMxnSqXXv+B3sISmgfMuYOAAAAAElFTkSuQmCC);
      }
      .questions {
        font-family: PingFangSC-Medium;
        margin-left: 16px;
        font-size: 20px;
        line-height: 33px;
        color: #333;
        letter-spacing: 0;
      }
    }
    .content {
      margin-top: 20px;
      line-height: 30px;
      display: flex;
      .answers-icon {
        width: 32px;
        height: 32px;
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAIKADAAQAAAABAAAAIAAAAACPTkDJAAADpElEQVRYCcVXTWgTQRT+ZtNUbRITa021SlH6B/5BqRYUFfyr9OBRRFAQLYiCBz0J4t2LoofSS714Ek9eROmhVEVBPYg/VZRaaZX+JzZNappkN+N702wqqdnsSlIfbHZ2dub73vvezNuMQI6NRuUWCXQIoA0StdT25gxx9Eg4MQgME04PtbvX+UT/nwDUN29SyvKxGG7S03kpoZn9xbwLgTThda314rIQIsnYyoEM+SMiPlBMwnxY5EgvOdHOTqhIOfKlImenmCujNgTnnPrelUp2CxU4HdvLeMHRYitJzvORc78KWKBDo0XQZjWwlO+YW+OtVkoSS2zi5hRY7nNt+idckWkYqyrhCk8htbEuixma0fH8cwyD4wmMR1Ko9rtRt3YZdjd5sdpXlh2Xr8HcYmSGsmFha65fI+IQpMcDbTaGqYtX8DYdxLOPUfQPxyFo9ZSVCQQDboSiOoy0BG0vbK1dgV2NXjStX26BTnMt39LL5KZ6VFDkgsgNnx96ZRVud49BuICa1eU43OxHS70H5eREypB4M/gLfR9m8H7ol7punLbOcEEHIsdOQSSTKB8aROjcJaXEQSJtrq9AQ818dBMRHS8pFTsaPGjNXJyWj9/jheJDwRQwgqGn4Y7HoHtXgrdNrr36Mou7vZM4vq8KezdbLqncqfb2/4Vb33Di9gTeDswuAlAdtIoMkl9S/tnuPQuj731UtQv92CpAaQNIpahw5Vmu9C0Bj+HXfL34FMU7WgN2zJYDHJ2KMK8DQJqiNxXQKWWS5tgxew5Q8GmWOIOYSEpcvTOM+30h1cMbmR00TfL4hUez+6/3gruAZzHgnwokdImBH3MIeOanmyl4/HoaLz/RdqXxK9y2YitcB0y3VbnK1CzeCKyIGaWpwGgoiYnpFNZQRWzfGTCnWt5tKWAiZFVlyUkFdsI0g8I+eaga+5tXqqJk9he629MpB4Vp05xnuthUzqntIjSuiE7snxzwVWhwE9HnoTjic7TiiVE5tCCIbR8cpcBEpW8NDrYE8PBFGGevf4Xf61IpefCUCtCbCH2gBDQK7ciOAPZs85nT/nq35UBbqx9h+tJtCC7Lgpw5GlQqPCHCkckENNJ/PJzAZITJBVwugVCjnh2fryFGZ2SUlHNWwPOhOewnIWMaHxoczivecOLWKPqe4iE6Q2Lu//63XMuc1bqc+V6U0V3MrarGfz+a8Rlt/qyGzswBsigh5oIwNl2d5rmQ3y+qm0t9PP8N5ESUFHS19TYAAAAASUVORK5CYII=);
      }
      .answers {
        width: 1100px;
        padding-left: 16px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #666;
        line-height: 30px;
        font-weight: 400;
      }
      .less {
        width: 1075px;
      }
      .zoom {
        align-self: flex-end;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #1072e0;
        text-align: right;
        cursor: pointer;
      }
    }
    .bottom {
      height: 30px;
      line-height: 30px;
      margin-top: 15px;
      display: flex;
      margin-left: 48px;
      align-items: center;
      .item-tag {
        min-width: 64px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        padding: 0 8px;
        background: #e8f0ff;
        border-radius: 12px;
        font-size: 12px;
        color: #1072e0;
      }
      .time {
        margin-left: 16px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #666;
        letter-spacing: 0;
      }
    }
  }
}
</style>
